import React, {useContext, useEffect, useState} from "react";
import './AdminView.css'
import {
    SlashCircle
} from "react-bootstrap-icons";
import HeadNavigation from "../../Components/HeadNavigation/HeadNavigation";
import {AccountTier, AdminUser, Api} from "../../RequestsProvider/RequestProvider";
import {Context} from "../../ContextProvider/Context";
import {AdminUserCard} from "../../Components/AdminUserCard/AdminUserCard";
import {BarLoader} from "react-spinners";


export const AdminView = () => {


    const context = useContext(Context)
    const request = useContext(Api)
    const {getAdminDashboard, getTierList} = request!
    const {setContentLoading} = context!
    const [adminUser, setAdminUser] = useState<AdminUser[] | null>(null)
    const [tierList, setTierList] = useState<AccountTier[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const fetchSettings = () => {
        getTierList().then(tl => {
            setTierList(tl.message)
            loadDash()
        })
        setInterval(() => loadDash, 15 * 60 * 1000)
    }

    const getTierById = (tierId: number) => {
        return tierList.find(tl => tl.tierID === tierId)!
    }
    const loadDash = () => {
        getAdminDashboard().then((resp) => {
            if (resp.message === 'unauthorizedError') {
                setIsLoading(false)
            } else {
                setAdminUser(resp.message as AdminUser[])
                setIsLoading(false)
            }
            setTimeout(() => setContentLoading(false), 600)
        })
    }

    const getUserStatusCode = (user: AdminUser) => {
        if (!user.emailVerified) {
            //'E-Mail Verifizierung'
            return 0
        }
        if (user.isAuthenticated === 'false') {
            if (user.qrCode) {
                //'QR-Code steht bereit'
                return 1
            } else {
                // 'Bot muss vom Admin zur Verfügung gestellt werden'
                return 2
            }
        } else {
            // 'Bot läuft'
            return 3
        }
    }
    useEffect(() => {
        setTimeout(() => fetchSettings(), 500)
    }, [])
    return (
        <>
            <HeadNavigation path={[{path: "/", pathName: "Startseite"}, {path: null, pathName: "Admin"}]}/>
            <div className="container">
                <div className="row mt-4">
                    {isLoading ? <div className={"text-center"}><p className={"text-muted"}>laden...</p><BarLoader
                        color={'var(--success-text)'}
                        height={2}
                        width={"20%"}
                        cssOverride={{
                            display: "block",
                            margin: "0 auto",
                        }}
                        speedMultiplier={.8}
                    /></div> : adminUser ? <>
                        <div className="site-header d-flex flex-column flex-lg-row justify-content-center">
                            <p className={"flex-item"}>Gesamt <span>[{adminUser.length}]</span></p>
                            <p className={"px-lg-4 flex-item"}>Bot läuft <span>[{adminUser.filter(usr => getUserStatusCode(usr) === 3).length}]</span></p>
                            <p className={"px-lg-4 flex-item"}>E-Mail Verifizierung <span>[{adminUser.filter(usr => getUserStatusCode(usr) === 0).length}]</span></p>
                            <p className={`px-lg-4 flex-item ${adminUser.filter(usr => getUserStatusCode(usr) === 2).length > 0? 'text-danger':null}`}>Bot bereitstellen <span>[{adminUser.filter(usr => getUserStatusCode(usr) === 2).length}]</span></p>
                            <p className={"flex-item"}>QR-Code steht bereit <span>[{adminUser.filter(usr => getUserStatusCode(usr) === 1).length}]</span></p>
                        </div>
                        {adminUser?.map(user => {
                            return (<div className="col-12 col-lg-4" key={user.id}>
                                <AdminUserCard user={user} accountTier={getTierById(user.tierID)}/>
                            </div>)
                        })} </> : <div className="login"><h1>
                        <SlashCircle className={"text-muted"} width={100} height={100}/>
                        <br/><small className={"text-muted fs-4"}>keine Berechtigung</small>
                    </h1></div>}
                </div>
            </div>
        </>
    )
}